export interface PersonFormValues {
  name: string;
  hospitalId: number | null;
  phoneNumber: string;
  email: string;
}

export interface IPerson {
  id?: number;
  name?: string;
  hospitalId?: number;
  hospitalName?: string;
  phoneNumber?: string;
  email?: string;
}

export const personInitialValues: PersonFormValues = {
  name: '',
  hospitalId: null,
  phoneNumber: '',
  email: '',
};

